namespace advisorop.services {
    `use strict`;

    export class AdvisoryApi {

        readonly apiUrl = `/api/advisory`;

        static $inject = [`$http`];
        constructor(private $http: ng.IHttpService) {
        }
        //getById(id: number): ng.IHttpPromise<domains.IAdvisor> {
        //    return this.$http.get(`${this.apiUrl}/${id}`);
        //}

        getAdvisoryFirms(): ng.IHttpPromise<domains.IAdvisoryFirm[]> {
            return this.$http.get(`${this.apiUrl}/firms`);
        };

        getAdvisoryFirmsForAdvisor(advisorId: number): ng.IHttpPromise<domains.IAdvisoryFirm[]> {
            return this.$http.get(`${this.apiUrl}/${advisorId}/firms`);
        };
    }
    angular.module(Constants.ADVOP_SERVICES).service("advisoryApi", AdvisoryApi);
}